var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "site-footer" }, [
    _c("div", { staticClass: "footer-legal" }, [
      _c("div", { staticClass: "flex flex-between content-max-width" }, [
        _c("div", { staticClass: "col" }, [
          _c("img", {
            staticClass: "logo",
            attrs: { src: "/images/icons/logo-icon.png", alt: "" }
          }),
          _vm._v(" "),
          _c("a", { staticClass: "tel", attrs: { href: "#" } }, [
            _vm._v(_vm._s(_vm.content.phone))
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "email",
              attrs: { href: "mailto:careers@glasslines.co.nz" }
            },
            [_vm._v(_vm._s(_vm.content.email_to))]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "copyright desktop" }, [
            _vm._v("© 2020 " + _vm._s(_vm.content.site_name) + ".\n          "),
            _c(
              "a",
              {
                staticClass: "attribution",
                attrs: {
                  href: "http://www.brownpaperbag.co.nz/",
                  target: "_blank"
                }
              },
              [_vm._v("Web Design by Brownpaperbag\n          ")]
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(0)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "flex social" }, [
        _c("div", { staticClass: "icon" }, [
          _c("a", { attrs: { href: "#" } }, [
            _c("img", { attrs: { src: "/images/icons/fb.svg", alt: "" } })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "icon" }, [
          _c("a", { attrs: { href: "#" } }, [
            _c("img", { attrs: { src: "/images/icons/ig.svg", alt: "" } })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("a", { attrs: { href: "/careers" } }, [_vm._v("Careers")])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("a", { attrs: { href: "/lifestyle" } }, [_vm._v("Lifestyle")])
        ]),
        _vm._v(" "),
        _c("li", [_c("a", { attrs: { href: "#" } }, [_vm._v("About Us")])])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "copyright mobile" }, [
        _vm._v("© 2020 Glasslines NZ Ltd.\n          "),
        _c(
          "a",
          {
            staticClass: "attribution",
            attrs: { href: "http://www.brownpaperbag.co.nz/", target: "_blank" }
          },
          [_vm._v("Web Design by Brownpaperbag\n          ")]
        )
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50e1e017", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e1e017","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Footer.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-50e1e017","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Footer.vue
// module chunks = 1